import { IContactStatus } from '../../types/contact-status';
import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const agentContactStatus: TComputedPropMapper<IContactStatus | undefined> = (props, ctx) => {
  if (props.offer.user?.canShowOnline) {
    return {
      label: 'Онлайн-показ',
      title: 'Выбирайте не выходя из дома',
      text:
        'Вам могут провести онлайн-показ объекта при помощи видеозвонка в WhatsApp, Viber, FaceTime или другой программы',
    };
  }

  return undefined;
};
